import cn from 'classnames';

import closeIcon from "../../icons/XCircle (1).svg";
import editIcon from "../../icons/NotePencil.svg";
import infoIcon from "../../icons/infoIcon.svg";
import styles from "./small.card.module.css";
import color from "../../styles/color.module.css";
import { Tooltip } from '@mui/material';

export default function SmallCard({ onClick, onSelect, avatar, title, subtitle, badge, onEdit, onInfo, onRemove, children, type = 'default', signatureIcon, tooltip }) {
  return (
    <div className={cn(styles.container, color[type], {
      [styles.pointer]: onClick,
    })}
      onClick={onClick}
    >
      <img onClick={onSelect && onSelect} className={styles.avatar} src={avatar} />
      <div className={styles.title_block}>
        <span className={styles.title}>
          {title}
        </span>
        <span className={styles.subtitle}>
          {subtitle}
        </span>
        {children}
      </div>
      {badge && badge}
      {onEdit && <img src={editIcon} onClick={onEdit} className={styles.editIcon} />}
      {onInfo && <img src={infoIcon} onClick={onInfo} className={styles.infoIcon} />}
      {onRemove && <img src={closeIcon} onClick={onRemove} className={styles.closeIcon} />}
      {signatureIcon &&
        <Tooltip title={tooltip}>
          <img className={styles.signatureIcon} src={signatureIcon} ></img>
        </Tooltip>}

    </div>
  )
}